<template>
  <div class="ModalCollect" v-show="isShow && !isHasUserCoupon ">
<!--    <i class="iconfont icon-cha" @click.stop="close"/>-->

<!--    <img v-lazy="imgLink" alt="">-->
  </div>
</template>

<script>
import {MODEL_COLLECT_BAR} from "@/constant/MODELS";
import {fnLocalStorage, fnLogin, fnUser} from "@/fn";
import {mapState} from "vuex";

const COLLECT_CLOSE_COUNT = 'collect_close_count';

export default {
  name: "ModalCollect",
  data() {
    return {
      isShow: false
      , imgLink:"https://js-oss.chaopx.com/chaotu/home/icon_collect.png"
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.user.isLogin
    },
    ...mapState('user',
      ['isHasUserCoupon']
    ),
  },
  watch: {
    isLogin(n, o) {
      if (n || !n) {
        setTimeout(() => {
          this.checkIsShow();
        }, 300)
      }
    }
  },
  mounted() {
    this.checkIsShow();
  },
  methods: {
    checkIsShow() {
      if (fnLogin.checkLogin()) {
        if (fnLocalStorage.getItem(COLLECT_CLOSE_COUNT) > 5) {
          return;
        }
        this.isShow = !fnLocalStorage.getItemDate(MODEL_COLLECT_BAR) ? true : false;
      }else{
        this.isShow = false;
      }
    },

    close() {
      this.isShow = false;
      fnLocalStorage.setItemDate(MODEL_COLLECT_BAR, 1);
      if (!fnLocalStorage.getItem(COLLECT_CLOSE_COUNT)) {
        fnLocalStorage.setItem(COLLECT_CLOSE_COUNT, 1);
      } else {
        let count = fnLocalStorage.getItem(COLLECT_CLOSE_COUNT);
        fnLocalStorage.setItem(COLLECT_CLOSE_COUNT, count += 1);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.ModalCollect {
  //@include BgImage(1200px, 98px, 'home/icon_collect.png');
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 99;
  width: 1200px;
  height: 98px;
  height: 0 !important;


  img{
    display: inline-block;
    width: 1200px;
    height: 98px;
    @include Position(1,5,0,0);
  }


  .icon-cha {
    font-size: 14px;
    color: #FFFFFF;
    @include Position(1, 5, 12px, 30px);
    cursor: pointer;
    z-index: 5;
  }
}
</style>
